import { StandbyMessage } from '../models/standby-message.interfaces';

export const StandbyMessageMocks: StandbyMessage = {
  action: {
    id: 'explore-skymiles',
    label: 'Explore Skymiles',
    url: 'us/en/skymiles/how-to-earn-miles/overview'
  },
  title: 'Welcome User',
  id: 'async-enrollment',
  message:
    'Your Skymiles enrollment request has been submitted. Please check your email for confirmation'
};
